import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// online
const firebaseConfig = {
  apiKey: "AIzaSyDEe8L_LIqtl1K6oz7Wu9wWWTnmrsHHXF8",
  authDomain: "cozytaps-f935d.firebaseapp.com",
  projectId: "cozytaps-f935d",
  storageBucket: "cozytaps-f935d.firebasestorage.app",
  messagingSenderId: "395430504581",
  appId: "1:395430504581:web:c52206fe7fc27bddb9e1ec"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export default {
  app,
  auth
};